import _ from 'lodash';
export var columnWidths = function columnWidths(columns) {
  var fullWidth = _.reduce(columns, function (acc, c) {
    var width = _.get(c, 'width', 1);

    return acc + width;
  }, 0);

  return _.map(columns, function (c) {
    var width = _.get(c, 'width', 1);

    var widthPercent = _.floor(width / fullWidth * 100);

    return "".concat(widthPercent, "%");
  });
};